import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import { Button } from "../../Components/ui/Button";
import { Checkbox } from "../../Components/ui/Checkbox";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../Components/ui/Form";
import { Input } from "../../Components/ui/Input";
import { resetPassword } from "../../lib/PB/Users";
import type { ResetPassword } from "../../Types/UserTypes";
import { resetPasswordschema } from "../../Types/UserTypes";
import { useState } from "react";
import { useUserStore } from "../../store/UserStore";

export const Route = createFileRoute("/Auth/ResetPassword")({
  component: ResetPassword,
});

export default function ResetPassword() {
  const form = useForm<ResetPassword>({
    resolver: zodResolver(resetPasswordschema),
  });
  const { loggedInUser } = useUserStore();

  const onSubmit = async (values: ResetPassword) => {
    console.log(values);
    resetPassword({ ...values, userId: loggedInUser.id });
  };
  const [oldPasswordType, setOldPasswordType] = useState("password");
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");

  return (
    <div>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="space-y-8 bg-white shadow-md rounded px-8 pt-6 pb-8 m-4"
        >
          <FormField
            control={form.control}
            name="oldPassword"
            defaultValue={""}
            render={({ field }) => {
              return (
                <FormItem className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <FormLabel>Your Old Password</FormLabel>
                  <FormControl>
                    <>
                      <Input
                        type={oldPasswordType}
                        placeholder="********"
                        {...field}
                      />
                      <div className="flex items-center space-x-2">
                        <Checkbox
                          id="oldPasswordType"
                          onCheckedChange={(checked) => {
                            console.log("m", checked);
                            if (checked) setOldPasswordType("text");
                            else setOldPasswordType("password");
                          }}
                        />
                        <label
                          htmlFor="oldPasswordType"
                          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          show password
                        </label>
                      </div>
                    </>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              );
            }}
          />
          <FormField
            control={form.control}
            name="newPassword"
            defaultValue={""}
            render={({ field }) => {
              return (
                <FormItem className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <FormLabel>Your New Password</FormLabel>
                  <FormControl>
                    <>
                      <Input
                        type={newPasswordType}
                        placeholder="********"
                        {...field}
                      />
                      <div className="flex items-center space-x-2">
                        <Checkbox
                          id="newPasswordType"
                          onCheckedChange={(checked) => {
                            console.log("m2", checked);
                            if (checked) setNewPasswordType("text");
                            else setNewPasswordType("password");
                          }}
                        />
                        <label
                          htmlFor="newPasswordType"
                          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          show password
                        </label>
                      </div>
                    </>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              );
            }}
          />
          <FormField
            control={form.control}
            name="confirmNewPassword"
            defaultValue={""}
            render={({ field }) => {
              return (
                <FormItem className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <FormLabel>Confirm New Password</FormLabel>
                  <FormControl>
                    <>
                      <Input
                        type={confirmPasswordType}
                        placeholder="********"
                        {...field}
                      />
                      <div className="flex items-center space-x-2">
                        <Checkbox
                          id="confirmPasswordType"
                          onCheckedChange={(checked) => {
                            console.log("m3", checked);
                            if (checked) setConfirmPasswordType("text");
                            else setConfirmPasswordType("password");
                          }}
                        />
                        <label
                          htmlFor="confirmPasswordType"
                          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          show password
                        </label>
                      </div>
                    </>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              );
            }}
          />
          <div className="flex justify-end">
            <Button variant="default" type="submit">
              Confirm
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
}
